import {Component, input, output} from '@angular/core';
import {TableConfig} from '../table.interfaces';
import {NgIf} from '@angular/common';
import {TranslateLabel} from "../../../pipes/translateLabel";

@Component({
    selector: 'app-table-filterbutton',
    templateUrl: './table-filterbutton.component.html',
    styleUrl: './table-filterbutton.component.scss',
    imports: [NgIf, TranslateLabel]
})
export class TableFilterbuttonComponent {

    config = input.required<TableConfig>();
    readonly changeColumnFilterActive = output();
    readonly changeColumnFilterReset = output();

    toggleFilter(): void {
        this.changeColumnFilterActive.emit();
    }

    checkFiltered(): boolean {
        return Object.values(this.config().dataConfig.columnFilter.fields).some((field: any) => {
            return field.value !== '';
        });
    }

    resetFilter(): void {
        Object.values(this.config().dataConfig.columnFilter.fields).forEach(field => {
            field.value = '';
        });
        this.changeColumnFilterReset.emit();
    }
}
